import React from 'react';
import classnames from 'classnames';
import { withStyles } from 'theme/withStyles';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import dialogActions from 'core/dialogs/actions';
import Button from 'common/Button';
import dialogStyles from './styles/dialog';
import contentWrapperStyles from './styles/contentWrapper';
import contentStyles from './styles/content';
import headerStyles from './styles/header';
import titleStyles from './styles/title';
import bodyStyles from './styles/body';
import footerStyles from './styles/footer';

const styles = (theme) => {
  const common = {
    body: bodyStyles(theme),
    content: contentStyles(theme),
    contentWrapper: contentWrapperStyles(theme),
    dialog: dialogStyles(theme),
    footer: footerStyles(theme),
    header: headerStyles(theme),
    title: titleStyles(theme),
  };
  return common;
};

export const ConfirmBare = ({ classes, close, commonClasses, message, onConfirm }) => (
  <div className={classnames('dialog-confirm', commonClasses, classes.dialog)}>
    <form className={classnames('modal-content', classes.content)}>
      <div className={classnames('modal-header', classes.header)}>
        <h4 className={classnames('modal-title', classes.title)} id="modal-title">
          {' '}
        </h4>
      </div>
      <div className={classnames('modal-body', classes.body)} id="modal-body">
        <div className={classnames('modal-content-wrapper', classes.contentWrapper)}>
          <p>{message}</p>
        </div>
      </div>
      <div className={classnames('modal-footer', classes.footer)}>
        <Button className="btn btn-primary popbox-btn0" data-key="0" onClick={onConfirm}>
          Yes
        </Button>
        <Button
          variant="secondary"
          className="btn btn-tertiary popbox-btn1"
          data-key="1"
          onClick={close}
        >
          No
        </Button>
      </div>
    </form>
  </div>
);

ConfirmBare.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  close: PropTypes.func.isRequired,
  commonClasses: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

const mapStateToProps = ({ dialogs }) => ({
  message: dialogs.params.message,
  onConfirm: dialogs.params.onConfirm,
});

const ConfirmStyled = withStyles(styles)(ConfirmBare);

export default connect(mapStateToProps, { close: dialogActions.close })(ConfirmStyled);
